import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from 'vue';
var DEFAULT_TRANSITION = 'fade';
export default (function (ctx, inject) {
  var emitter = new Vue();
  var $modal = {
    show: function show(name, params) {
      emitter.$emit('toggle', name, true, params);
      this.current = name;
      return this;
    },
    hide: function hide(name, params) {
      emitter.$emit('toggle', name || this.current, false, params);
      if (this.current === name) this.current = null;
      return this;
    },
    toggle: function toggle(name, params) {
      emitter.$emit('toggle', name, undefined, params);
      // FIXME: there is the case when we override the prev modal, but not hide it
      //        we should use array for modals
      if (this.current === name) {
        this.current = null;
      } else {
        this.current = name;
      }
      return this;
    },
    showWithRoute: function showWithRoute(modal) {
      var queryAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _ctx$app = ctx.app,
        $utils = _ctx$app.$utils,
        $constants = _ctx$app.$constants,
        route = ctx.route;
      // @ts-ignore
      var modalName = modal.custom || $constants.dynamicModals[modal] || modal;

      // @ts-ignore
      $utils.routePushWithQuery(route, {
        query: _objectSpread({
          dynamic_modal: modalName
        }, queryAttrs)
      });
      this.current = modalName;
      return this;
    },
    emitter: emitter,
    current: null,
    // Quick workaround to change a transition of modal
    // It's reactive, because we need to watch it for Portal to change the transition
    // TODO: make it more flexible (e.g add a transition to the modal itself)
    options: Vue.observable({
      transition: DEFAULT_TRANSITION
    })
  };
  inject('modal', $modal);
});